export default "__VITE_ASSET__95SZrBxF__"